import { connect } from 'react-redux'

import { clearSelection, closeDetails, toggleShowSelectedOnly } from './actions'
import SearchSummary from './SearchSummary'
import { getDetails } from './selectors'

const mapStateToProps = state => ({
  hasDetails: Boolean(getDetails(state)),
  selectedStoresCount: state.search.selectedStores.length,
  showSelectedOnly: state.search.showSelectedOnly,
})

const mapDispatchToProps = {
  clearSelection,
  closeDetails,
  toggleShowSelectedOnly,
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchSummary)
